import type { ViewEntity } from '@/engine/app/models/viewEntity/view.entity';
import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import { AddOrientationPresetCommand } from './AddOrientationPreset.command';
import type { IViewPortOrientation } from '@/engine/app/interfaces';
import { RemoveOrientationPresetCommand } from './RemoveOrientationPreset.command';

export enum OrientationPresetsCommandType {
  AddPreset = 'AddPreset',
  RemovePreset = 'RemovePreset'
}

@injectable()
export class OrientationPresetsCommandsFactory {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  public constructor(@inject(TYPES.PlanningAlgorithm) planningAlgorithm: PlanningAlgorithm) {
    this._planningAlgorithm = planningAlgorithm;
  }

  public createCommand(
    view: ViewEntity,
    label: string,
    descriptor: string,
    orientation: IViewPortOrientation,
    commandType: OrientationPresetsCommandType
  ): ICommand {
    switch (commandType) {
      case OrientationPresetsCommandType.AddPreset:
        return new AddOrientationPresetCommand(view, label, descriptor, orientation, this._planningAlgorithm);
      case OrientationPresetsCommandType.RemovePreset:
        return new RemoveOrientationPresetCommand(view, label, descriptor, orientation, this._planningAlgorithm);
      default:
        throw new Error('Invalid command type');
    }
  }
}
